import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import { toPaginatedCollection, type PaginationMeta } from 'tio-common/types/ember-data';
import type { EligibilityFileJobLogExtension as EligibilityFileJobLogModel } from 'tio-data/data/resources/eligibility-file-job-log.ext';
import type { Store } from '@warp-drive/core';
import type PartnerService from 'tio-employee/services/partner';
import type RouterService from '@ember/routing/router';

export default class AuthenticatedAdminEligibilityFilesIndexRoute extends Route {
  @service declare store: Store;
  @service declare partner: PartnerService;
  @service declare router: RouterService;

  queryParams = {
    startDate: { refreshModel: true, replace: true },
    status: { refreshModel: true, replace: true },
    sort: { refreshModel: true, replace: true },
    page: { refreshModel: true, replace: true },
    limit: { refreshModel: true, replace: true },
  };
  includes = ['company.user'];

  async model(params: {
    status: string;
    startDate: string;
    sort: string;
    page: number;
    limit: number;
  }) {
    const { sort, startDate, page, limit, status } = params;

    // Build flattened bracket-key params for the query builder.
    // Nested filter/page objects must be flattened to satisfy QueryParamsSource.
    const flatParams: Record<string, string | number | boolean> = {
      'filter[company-id]': this.partner.company?.id as string,
      'page[limit]': limit,
      'page[offset]': (page - 1) * limit,
      include: this.includes.join(','),
      sort,
    };

    if (startDate) {
      flatParams['filter[start-date]'] = startDate;
    }

    // TODO: This seems like it should just be handled by the query param, but quick fix for now
    if (status && status.toLocaleLowerCase() !== 'all') {
      flatParams['filter[status]'] = status;
    }

    const { content } = (await this.store.request(
      query<EligibilityFileJobLogModel>('eligibility-file-job-log', flatParams)
    )) as { content: { data: EligibilityFileJobLogModel[]; meta?: PaginationMeta | null } };

    return toPaginatedCollection(content);
  }
}
